import React from "react";
import * as Mui from "@mui/material";
import { Logo } from "../logo";
import { IntegrationType } from "type/integration-type";
import { AddButton } from "../add-button";

interface Props {
	integrationType: IntegrationType;
	onClose: Function;
}

class Component extends React.Component<Props> {

	public render() {
		const { integrationType, onClose } = this.props;
		return (
			<Mui.Grid container direction="column" spacing={2}>
				<Mui.Grid item>
					<Logo integrationType={integrationType} />
				</Mui.Grid>
				<Mui.Grid item>
					<Mui.Typography>
						Top Producer® CRM is designed specifically to help you capture and convert prospects, guide current clients to closing and maximize repeat and referral business to turn more consumers into lifelong clients.
					</Mui.Typography>
				</Mui.Grid>
				<Mui.Grid item>
					<Mui.Typography>
						Forwards information for new leads to your Top Producer account in the "Lead Transmission Standard" data format.
					</Mui.Typography>
				</Mui.Grid>
				<Mui.Grid item>
					<AddButton integrationType={integrationType} onClose={onClose} />
				</Mui.Grid>
			</Mui.Grid>
		);
	}

}

export const TopProducerLtsIntegration = Component;